// Central product data - Single source of truth
// Updated to match exact business structure

// Import Category Images
import oilsNaturalExtractsImg from '../assets/images/categories/oils-natural-extracts.jpg';
import spicesPowdersImg from '../assets/images/products/spices_and_powder.avif';
import milletsGrainsImg from '../assets/images/products/millet_and_grains_new.jpg';
import naturalSweetenersImg from '../assets/images/products/Natral_sweet.jpg';
import freshProduceImg from '../assets/images/products/fresh_produce.jpg';
import palmProductsImg from '../assets/images/products/palm_product.jpg';
import organicFertilizersImg from '../assets/images/categories/organic-fertilizers.jpg';
import handicraftsImg from '../assets/images/products/Handicrafts.jpg';

// Import Product Images
import coconutOilImg from '../assets/images/products/coconut-oil_new.jpg';
import groundnutOilImg from '../assets/images/products/groundnut-oil_new.jpg';
import turmericPowderImg from '../assets/images/products/turmeric-powder_new.jpg';
import chilliFlakesImg from '../assets/images/products/chilli-flakes_new.jpg';
import murungaLeafPowderImg from '../assets/images/products/murunga-leaf-powder_new.jpg';
import idlyPowderImg from '../assets/images/products/idly-powder_new.jpg';
import littleMilletImg from '../assets/images/products/little-millet_new.jpg';
import milletsVarietiesImg from '../assets/images/products/millets-varieties_new.jpg';
import milletFlakesImg from '../assets/images/products/millet-flakes_new.jpg';
import ponniRiceImg from '../assets/images/products/ponni-rice.jpg';
import honeyImg from '../assets/images/products/honey_1.jpg';
import drumsticksImg from '../assets/images/products/drumsticks_new.jpg';
import bananaImg from '../assets/images/products/banana_new.jpg';
import bananaLeavesImg from '../assets/images/products/banana-leaves_new.jpg';
import betelLeavesImg from '../assets/images/products/betal_new.jpg';
import palmyraSproutFlourImg from '../assets/images/products/palmyra-sprout-flour_new.jpg';
import palmJaggeryImg from '../assets/images/products/palm-jaggery_new.jpg';
import palmSugarImg from '../assets/images/products/palm_sugar_newwwww.jpg';
import cowDungPowderImg from '../assets/images/products/cow-dung-powder_new.jpg';
import fishAminoAcidImg from '../assets/images/products/fish-amino-acid_new.jpg';
import panchagavyaImg from '../assets/images/products/panchagavya_new.jpg';
import potteryImg from '../assets/images/products/pottery_new.jpg';
import koraiPaiImg from '../assets/images/products/korai-pai_new.jpg';
import handheldFanImg from '../assets/images/products/handheld-fan_new.jpg';

export const categories = [
  {
    id: 'oils-natural-extracts',
    name: 'Oils & Natural Extracts',
    slug: 'oils-natural-extracts',
    image: oilsNaturalExtractsImg,
    description: 'Premium quality oils extracted naturally'
  },
  {
    id: 'spices-powders',
    name: 'Spices & Powders',
    slug: 'spices-powders',
    image: spicesPowdersImg,
    description: 'Authentic Indian spices and powder blends'
  },
  {
    id: 'millets-grains',
    name: 'Millets & Grains',
    slug: 'millets-grains',
    image: milletsGrainsImg,
    description: 'Nutritious millets and premium rice varieties'
  },
  {
    id: 'natural-sweeteners',
    name: 'Natural Sweeteners',
    slug: 'natural-sweeteners',
    image: naturalSweetenersImg,
    description: 'Pure honey and natural sweetening alternatives'
  },
  {
    id: 'fresh-produce',
    name: 'Fresh Produce',
    slug: 'fresh-produce',
    image: freshProduceImg,
    description: 'Farm-fresh vegetables and produce'
  },
  {
    id: 'palm-products',
    name: 'Palm Products',
    slug: 'palm-products',
    image: palmProductsImg,
    description: 'Traditional palm-based natural products'
  },
  {
    id: 'organic-fertilizers',
    name: 'Organic Fertilizers',
    slug: 'organic-fertilizers',
    image: organicFertilizersImg,
    description: 'Natural organic fertilizers and soil enhancers'
  },
  {
    id: 'handicrafts',
    name: 'Handicrafts',
    slug: 'handicrafts',
    image: handicraftsImg,
    description: 'Traditional handcrafted items'
  }
];


export const products = [
  // Oils & Natural Extracts (2 products)
  {
    id: 'coconut-oil',
    name: 'Coconut Oil',
    category: 'oils-natural-extracts',
    image: coconutOilImg,
    shortDescription: 'Pure cold-pressed coconut oil',
    description: 'Premium quality cold pressed coconut oil processed to retain natural aroma and nutrients.',
    overview: 'Carefully sourced from trusted suppliers and processed using traditional cold-press methods to preserve natural aroma, flavor, and nutritional properties. This premium coconut oil is hygienically processed and packed under stringent quality controls to meet international export standards. Suitable for bulk supply to food manufacturers, cosmetic industries, and retail distribution worldwide.',
    specifications: [
      { label: 'Product Type', value: 'Virgin / Cold Pressed' },
      { label: 'Purity', value: '100% Pure' },
      { label: 'Moisture Content', value: '≤0.1%' },
      { label: 'Free Fatty Acid (FFA)', value: '≤0.5%' },
      { label: 'Packaging', value: 'Food-grade containers, Export cartons' },
      { label: 'Shelf Life', value: '12–18 Months' }
    ],
    exportNote: 'Suitable for food, cosmetic, and industrial applications.'
  },
  {
    id: 'groundnut-oil',
    name: 'Organic Wood-Pressed Groundnut Oil',
    category: 'oils-natural-extracts',
    image: groundnutOilImg,
    shortDescription: 'Traditional wood-pressed groundnut oil',
    description: 'Cold pressed groundnut oil retaining natural taste and nutrition.',
    overview: 'Traditionally extracted using wooden cold-press methods to retain authentic taste, aroma, and nutritional value. Sourced from quality groundnuts and processed under hygienic conditions. This organic oil is prepared following natural extraction methods and packed to meet international food safety and export standards. Ideal for culinary use and food processing applications.',
    specifications: [
      { label: 'Processing Method', value: 'Wood Pressed / Cold Pressed' },
      { label: 'Quality Grade', value: 'Organic' },
      { label: 'Free Fatty Acid (FFA)', value: '≤0.5%' },
      { label: 'Application', value: 'Cooking, Food Processing' },
      { label: 'Packaging', value: 'Export-grade containers' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Ideal for cooking and food processing applications.'
  },

  // Spices & Powders (4 products)
  {
    id: 'turmeric-powder',
    name: 'Turmeric Powder',
    category: 'spices-powders',
    image: turmericPowderImg,
    shortDescription: 'Pure organic turmeric powder',
    description: 'High-curcumin turmeric powder with strong color and natural fragrance.',
    overview: 'Premium turmeric powder sourced from quality farms and processed under hygienic conditions to preserve natural color, aroma, and curcumin content. The powder is carefully dried, ground to fine mesh, and packed in moisture-proof packaging to meet international quality standards. Suitable for culinary applications, food coloring, spice blends, and nutraceutical industries worldwide.',
    specifications: [
      { label: 'Curcumin Content', value: '≥3%' },
      { label: 'Color', value: 'Bright Yellow/Orange' },
      { label: 'Moisture Content', value: '≤10%' },
      { label: 'Mesh Size', value: '80–100' },
      { label: 'Application', value: 'Culinary, Food Coloring, Nutraceuticals' },
      { label: 'Shelf Life', value: '24 Months' }
    ],
    exportNote: 'Perfect for food coloring, spice blends, and nutraceutical applications.'
  },
  {
    id: 'chilli-flakes',
    name: 'Chilli Flakes',
    category: 'spices-powders',
    image: chilliFlakesImg,
    shortDescription: 'Premium dried chilli flakes',
    description: 'Premium chilli flakes offering consistent heat and vibrant color.',
    overview: 'Premium quality chilli flakes prepared from carefully selected red chillies, hygienically dried and processed to retain natural color, heat, and flavor. The flakes are cleaned, sorted, and packed to ensure consistent quality and meet international food safety standards. Ideal for food processing, restaurant use, and retail distribution in global markets.',
    specifications: [
      { label: 'Color', value: 'Bright Red' },
      { label: 'Heat Level', value: 'Medium to High' },
      { label: 'Moisture Content', value: '≤10%' },
      { label: 'Processing', value: 'Hygienically Dried & Flaked' },
      { label: 'Application', value: 'Food Processing, Culinary Use' },
      { label: 'Shelf Life', value: '18 Months' }
    ],
    exportNote: 'Suitable for food processing and culinary applications worldwide.'
  },
  {
    id: 'murunga-leaf-powder',
    name: 'Murunga Leaf Powder',
    category: 'spices-powders',
    image: murungaLeafPowderImg,
    shortDescription: 'Nutrient-rich drumstick leaf powder',
    description: 'Naturally dried moringa leaves finely powdered for nutritional applications.',
    overview: 'Moringa (drumstick) leaves are carefully harvested, shade-dried to preserve nutrients, and finely ground into powder form. This superfood powder is processed under hygienic conditions and packed to retain its natural dark green color and nutritional profile. Prepared to meet export quality standards for health supplement and nutraceutical industries worldwide.',
    specifications: [
      { label: 'Product Type', value: '100% Pure Leaf Powder' },
      { label: 'Color', value: 'Dark Green' },
      { label: 'Moisture Content', value: '≤7%' },
      { label: 'Processing Method', value: 'Shade Dried & Finely Ground' },
      { label: 'Application', value: 'Health Supplements, Nutraceuticals' },
      { label: 'Shelf Life', value: '18–24 Months' }
    ],
    exportNote: 'Ideal for health supplements and nutritional products.'
  },
  {
    id: 'idly-powder',
    name: 'Idly Powder (Varieties)',
    category: 'spices-powders',
    image: idlyPowderImg,
    shortDescription: 'Traditional South Indian idly powder varieties',
    description: 'Traditional South Indian spice blend prepared under hygienic conditions.',
    overview: 'Authentic South Indian idly powder prepared using traditional recipes and premium quality ingredients. This spice blend is hygienically processed, roasted, and ground to preserve authentic flavor and aroma. Packed in moisture-proof packaging to maintain freshness and meet export quality standards. Ideal for South Asian cuisine and specialty food markets worldwide.',
    specifications: [
      { label: 'Product Type', value: 'Traditional Spice Blend' },
      { label: 'Varieties', value: 'Multiple South Indian Flavors' },
      { label: 'Moisture Content', value: '≤8%' },
      { label: 'Processing', value: 'Roasted & Ground' },
      { label: 'Application', value: 'Culinary Use, Retail Distribution' },
      { label: 'Shelf Life', value: '6–9 Months' }
    ],
    exportNote: 'Authentic South Indian flavor for international markets.'
  },

  // Millets & Grains (4 products)
  {
    id: 'little-millet',
    name: 'Little Millet',
    category: 'millets-grains',
    image: littleMilletImg,
    shortDescription: 'Nutritious little millet grains',
    description: 'Carefully cleaned millets prepared for international shipment.',
    overview: 'Premium little millet grains carefully cleaned, graded, and sorted to ensure high purity levels. Sourced from reliable farms and processed under hygienic conditions to meet international quality standards. Packed in export-grade packaging to preserve freshness and nutritional value. Ideal for health food manufacturers, retail distribution, and bulk supply to global markets.',
    specifications: [
      { label: 'Purity Level', value: '≥99%' },
      { label: 'Moisture Content', value: '≤12%' },
      { label: 'Processing', value: 'Cleaned & Graded' },
      { label: 'Packaging', value: 'Export-grade Polypropylene Bags' },
      { label: 'Application', value: 'Health Foods, Retail Distribution' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Premium quality millet for health-conscious global markets.'
  },
  {
    id: 'millets',
    name: 'Millets (All Varieties)',
    category: 'millets-grains',
    image: milletsVarietiesImg,
    shortDescription: 'Various healthy millet varieties',
    description: 'Carefully cleaned millets prepared for international shipment.',
    overview: 'Diverse range of millet varieties including foxtail, pearl, finger, and other regional types. Each variety is carefully sourced, cleaned, and graded to maintain quality and purity. Processed and packed under stringent hygiene standards to meet international export requirements. Suitable for health food industries, specialty food markets, and bulk distribution worldwide.',
    specifications: [
      { label: 'Varieties Available', value: 'Foxtail, Pearl, Finger, Kodo & More' },
      { label: 'Purity Level', value: '≥99%' },
      { label: 'Moisture Content', value: '≤12%' },
      { label: 'Processing', value: 'Cleaned & Sorted' },
      { label: 'Application', value: 'Health Foods, Culinary Use' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Diverse millet varieties for different culinary applications.'
  },
  {
    id: 'millet-flakes',
    name: 'Millet Flakes',
    category: 'millets-grains',
    image: milletFlakesImg,
    shortDescription: 'Ready-to-cook millet flakes',
    description: 'Lightweight millet flakes ideal for quick cooking and breakfast products.',
    overview: 'Ready-to-cook millet flakes prepared through steam rolling process to ensure quick cooking and easy digestibility. These lightweight flakes are processed from quality millets and packed to preserve freshness and nutritional content. Ideal for breakfast cereal manufacturers, instant food products, and health food distribution. Meets international food safety and export standards.',
    specifications: [
      { label: 'Processing Method', value: 'Steam Rolled' },
      { label: 'Texture', value: 'Lightweight & Quick Cooking' },
      { label: 'Moisture Content', value: '≤12%' },
      { label: 'Packaging', value: 'Moisture-proof Export Packaging' },
      { label: 'Application', value: 'Breakfast Cereals, Instant Foods' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Convenient format for modern breakfast cereals and instant foods.'
  },
  {
    id: 'ponni-rice',
    name: 'Ponni Rice',
    category: 'millets-grains',
    image: ponniRiceImg,
    shortDescription: 'Premium quality Ponni rice',
    description: 'Popular South Indian rice variety packed for bulk export.',
    overview: 'Premium Ponni rice, a popular South Indian variety known for its medium grain size, soft texture, and excellent cooking quality. Carefully cleaned, graded, and sorted to minimize broken grains and impurities. Processed and packed under hygienic conditions to meet international export standards. Suitable for bulk supply to restaurants, retail chains, and wholesale distributors worldwide.',
    specifications: [
      { label: 'Grain Type', value: 'Medium Grain' },
      { label: 'Broken Grains', value: '≤5%' },
      { label: 'Moisture Content', value: '≤14%' },
      { label: 'Processing', value: 'Cleaned & Graded' },
      { label: 'Application', value: 'Culinary Use, Bulk Distribution' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Preferred rice variety for South Indian cuisine worldwide.'
  },

  // Natural Sweeteners (1 product)
  {
    id: 'honey',
    name: 'Honey',
    category: 'natural-sweeteners',
    image: honeyImg,
    shortDescription: 'Pure natural honey',
    description: 'Pure natural honey sourced directly from trusted producers.',
    overview: 'Premium quality natural honey sourced from trusted beekeepers and carefully collected to preserve natural flavor, aroma, and nutritional properties. This pure honey is hygienically processed, filtered to remove impurities, and packed under stringent quality controls to meet international food safety standards. Suitable for food processing, beverage manufacturing, retail distribution, and pharmaceutical applications worldwide.',
    specifications: [
      { label: 'Product Type', value: 'Pure Natural Honey' },
      { label: 'Moisture Content', value: '≤20%' },
      { label: 'Quality', value: 'No Added Sugar or Additives' },
      { label: 'Processing', value: 'Filtered & Hygienically Packed' },
      { label: 'Application', value: 'Food, Beverage, Pharmaceutical' },
      { label: 'Shelf Life', value: '24 Months' }
    ],
    exportNote: 'Naturally sweet and perfect for food and beverage applications.'
  },

  // Fresh Produce (4 products)
  {
    id: 'drumsticks',
    name: 'Drumsticks',
    category: 'fresh-produce',
    image: drumsticksImg,
    shortDescription: 'Fresh farm-grown drumsticks',
    description: 'Freshly harvested drumsticks supplied according to seasonal availability.',
    overview: 'Fresh farm-grown drumsticks (moringa) carefully harvested during peak season to ensure optimal quality and freshness. Sourced from trusted farms and hygienically packed to preserve freshness during transit. Available in fresh or dried form, packed in export-grade packaging to meet international shipping and food safety standards. Ideal for food processing, restaurants, and retail distribution worldwide.',
    specifications: [
      { label: 'Product Form', value: 'Fresh or Dried' },
      { label: 'Quality', value: 'Export Grade' },
      { label: 'Processing', value: 'Hygienically Harvested & Packed' },
      { label: 'Packaging', value: 'Export-grade Cold Chain Packaging' },
      { label: 'Application', value: 'Food Processing, Culinary Use' },
      { label: 'Shelf Life', value: 'Fresh 7 Days / Dried 12 Months' }
    ],
    exportNote: 'Carefully packed to maintain freshness during international shipping.'
  },
  {
    id: 'banana',
    name: 'Banana',
    category: 'fresh-produce',
    image: bananaImg,
    shortDescription: 'Fresh farm-grown bananas',
    description: 'Fresh farm-grown bananas supplied according to seasonal availability.',
    overview: 'Premium quality fresh bananas sourced from trusted farms and carefully selected at the proper ripening stage for export. Each bunch is inspected for quality, cleaned, and packed in ventilated cartons to ensure freshness during international transit. Prepared according to export standards to meet requirements for global markets including retail chains, wholesale distributors, and food service industries.',
    specifications: [
      { label: 'Quality Grade', value: 'Export Grade' },
      { label: 'Ripening Stage', value: 'Proper Ripening for Export' },
      { label: 'Processing', value: 'Cleaned & Inspected' },
      { label: 'Packaging', value: 'Ventilated Export Cartons' },
      { label: 'Application', value: 'Fresh Consumption, Retail Distribution' },
      { label: 'Shelf Life', value: '7-10 Days' }
    ],
    exportNote: 'Carefully selected and packed for international markets.'
  },
  {
    id: 'banana-leaves',
    name: 'Banana Leaves',
    category: 'fresh-produce',
    image: bananaLeavesImg,
    shortDescription: 'Fresh banana leaves for traditional use',
    description: 'Fresh banana leaves supplied for traditional and culinary applications.',
    overview: 'Fresh banana leaves harvested from quality plantations and carefully cleaned for traditional culinary and serving applications. These large, green leaves are hygienically processed and packed to preserve freshness during transit. Ideal for traditional food serving, eco-friendly packaging, and cultural culinary applications. Meets export standards for international markets seeking authentic and sustainable food presentation solutions.',
    specifications: [
      { label: 'Product Type', value: 'Fresh Green Banana Leaves' },
      { label: 'Size', value: 'Large Size' },
      { label: 'Quality', value: 'Fresh, Clean, and Green' },
      { label: 'Processing', value: 'Hygienically Cleaned & Packed' },
      { label: 'Application', value: 'Traditional Food Serving, Eco-packaging' },
      { label: 'Shelf Life', value: '3-5 Days' }
    ],
    exportNote: 'Ideal for traditional food serving and eco-friendly packaging.'
  },
  {
    id: 'betel-leaves',
    name: 'Betel Leaves',
    category: 'fresh-produce',
      image: betelLeavesImg,
    shortDescription: 'Fresh betel leaves',
    description: 'Fresh betel leaves sourced from quality farms.',
    overview: 'Fresh premium quality betel leaves carefully sourced from trusted farms and harvested at the right maturity stage. Each leaf is inspected for quality, cleaned, and hygienically packed to preserve freshness during international transit. Prepared to meet export standards for traditional use in cultural practices, culinary applications, and specialized markets worldwide.',
    specifications: [
      { label: 'Product Type', value: 'Fresh Green Betel Leaves' },
      { label: 'Quality', value: 'Premium Export Grade' },
      { label: 'Processing', value: 'Hygienically Cleaned & Inspected' },
      { label: 'Packaging', value: 'Moisture-retaining Export Packaging' },
      { label: 'Application', value: 'Traditional Use, Cultural Practices' },
      { label: 'Shelf Life', value: '3-5 Days' }
    ],
    exportNote: 'Carefully packed to preserve freshness for export.'
  },

  // Palm Products (3 products)
  {
    id: 'palmyra-sprout-flour',
    name: 'Palmyra Sprout Flour (PanaKilangu Maavu)',
    category: 'palm-products',
    image: palmyraSproutFlourImg,
    shortDescription: 'Traditional palmyra sprout flour',
    description: 'Traditional palm-based flour hygienically processed from palmyra sprouts.',
    overview: 'Traditional palmyra sprout flour (PanaKilangu Maavu) prepared from quality palmyra tubers, carefully cleaned, dried, and finely ground. This nutritious flour is processed under hygienic conditions to preserve natural nutrients and flavor. Packed in moisture-proof packaging to meet export standards. Ideal for traditional recipes, health food products, and specialty food markets worldwide.',
    specifications: [
      { label: 'Product Type', value: '100% Pure Palmyra Sprout Flour' },
      { label: 'Processing', value: 'Dried & Finely Ground' },
      { label: 'Moisture Content', value: '≤8%' },
      { label: 'Packaging', value: 'Moisture-proof Export Packaging' },
      { label: 'Application', value: 'Traditional Recipes, Health Foods' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Natural and nutritious flour for traditional recipes.'
  },
  {
    id: 'palm-jaggery',
    name: 'Palm Jaggery',
    category: 'palm-products',
    image: palmJaggeryImg,
    shortDescription: 'Natural palm jaggery',
    description: 'Traditional palm-based sweetener hygienically processed for export.',
    overview: 'Natural palm jaggery prepared from fresh palm sap collected from quality palm trees. The sap is carefully boiled, concentrated, and solidified using traditional methods to preserve natural minerals and flavor. This unrefined sweetener is hygienically processed and packed to meet international export standards. Ideal for health-conscious markets seeking natural sweetening alternatives.',
    specifications: [
      { label: 'Product Type', value: 'Natural Palm Jaggery (Unrefined)' },
      { label: 'Processing', value: 'Traditional Boiling & Solidification' },
      { label: 'Moisture Content', value: '≤8%' },
      { label: 'Quality', value: 'Rich in Natural Minerals' },
      { label: 'Application', value: 'Natural Sweetener, Food Processing' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Natural sweetener with rich mineral content for health-conscious markets.'
  },
  {
    id: 'palm-sugar',
    name: 'Palm Sugar',
    category: 'palm-products',
    image: palmSugarImg,
    shortDescription: 'Pure palm sugar',
    description: 'Traditional palm-based sugar hygienically processed for export.',
    overview: 'Pure palm sugar produced from fresh palm sap through careful evaporation and crystallization processes. This natural sweetener is processed under hygienic conditions to preserve its characteristic flavor and nutritional properties. Packed in moisture-proof packaging to meet export quality standards. Suitable for food processing industries, bakery applications, and as an alternative sweetener in global markets.',
    specifications: [
      { label: 'Product Type', value: 'Pure Palm Sugar (Crystallized)' },
      { label: 'Processing', value: 'Evaporation & Crystallization' },
      { label: 'Moisture Content', value: '≤8%' },
      { label: 'Quality', value: 'Natural & Unrefined' },
      { label: 'Application', value: 'Food Processing, Bakery, Alternative Sweetener' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Ideal alternative sweetener for food processing industries.'
  },

  // Organic Fertilizers (3 products)
  {
    id: 'cow-dung-dry-powder',
    name: 'Cow Dung Dry Powder',
    category: 'organic-fertilizers',
    image: cowDungPowderImg,
    shortDescription: 'Organic cow dung dry powder for agriculture',
    description: 'Used for organic farming and eco-friendly agricultural practices.',
    overview: 'Organic cow dung dry powder and cakes prepared from quality cow manure, naturally dried and processed to preserve organic content. This natural fertilizer is hygienically handled, dried, and packed to meet export standards for organic farming applications. Rich in essential nutrients, it supports sustainable agriculture and soil enrichment. Ideal for organic farming industries, nurseries, and eco-friendly agricultural projects worldwide.',
    specifications: [
      { label: 'Product Form', value: 'Dried Cakes / Fine Powder' },
      { label: 'Processing', value: 'Naturally Dried & Processed' },
      { label: 'Quality', value: 'Natural Organic Content' },
      { label: 'Application', value: 'Organic Farming, Soil Enrichment' },
      { label: 'Packaging', value: 'Export-grade Polypropylene Bags' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Supports sustainable agriculture and soil enrichment.'
  },
  {
    id: 'fish-amino-acid',
    name: 'Fish Amino Acid',
    category: 'organic-fertilizers',
    image: fishAminoAcidImg,
    shortDescription: 'Natural fish amino acid fertilizer',
    description: 'Natural fish amino acid solution for organic farming.',
    overview: 'Natural fish amino acid liquid fertilizer prepared from quality fish waste through fermentation processes. This organic solution is rich in nitrogen and amino acids, promoting healthy plant growth naturally. Processed under hygienic conditions and bottled to meet export standards for organic farming applications. Suitable for crop cultivation, horticulture, and sustainable farming practices worldwide.',
    specifications: [
      { label: 'Product Type', value: 'Organic Liquid Fertilizer' },
      { label: 'Processing', value: 'Fermented Fish Extract' },
      { label: 'Nutrient Content', value: 'High Nitrogen & Amino Acids' },
      { label: 'Application', value: 'Crop Cultivation, Horticulture' },
      { label: 'Packaging', value: 'Export-grade Liquid Containers' },
      { label: 'Shelf Life', value: '12 Months' }
    ],
    exportNote: 'Promotes healthy plant growth naturally.'
  },
  {
    id: 'panchagavya',
    name: 'Panchagavya',
    category: 'organic-fertilizers',
    image: panchagavyaImg,
    shortDescription: 'Traditional panchagavya organic solution',
    description: 'Traditional organic solution for sustainable farming.',
    overview: 'Traditional panchagavya organic solution prepared from five cow-based ingredients following ancient formulations. This natural bio-enhancer is carefully fermented and processed to preserve beneficial microorganisms and nutrients. Prepared under hygienic conditions and bottled to meet export standards. Ideal for organic farming, crop protection, and sustainable agricultural practices in global markets.',
    specifications: [
      { label: 'Product Type', value: 'Five Cow-based Ingredients' },
      { label: 'Processing', value: 'Traditional Fermentation' },
      { label: 'Quality', value: 'Natural Formulation with Beneficial Microbes' },
      { label: 'Application', value: 'Organic Farming, Crop Protection' },
      { label: 'Packaging', value: 'Export-grade Liquid Containers' },
      { label: 'Shelf Life', value: '6 Months' }
    ],
    exportNote: 'Ancient formula for modern organic agriculture.'
  },

  // Handicrafts (3 products)
  {
    id: 'pottery',
    name: 'Pottery',
    category: 'handicrafts',
    image: potteryImg,
    shortDescription: 'Traditional handcrafted pottery',
    description: 'Handcrafted pottery products supporting rural artisans.',
    overview: 'Traditional handcrafted pottery made by skilled rural artisans using natural clay and time-honored techniques. Each piece is carefully shaped, dried, and fired to create durable and functional art. Finished with non-toxic glazes and packed in export-safe packaging to prevent damage during transit. These authentic handmade products promote traditional craftsmanship and support rural livelihoods in global markets.',
    specifications: [
      { label: 'Material', value: 'Natural Clay' },
      { label: 'Production', value: 'Handcrafted by Skilled Artisans' },
      { label: 'Finish', value: 'Non-toxic Glaze' },
      { label: 'Packaging', value: 'Export-safe Packaging' },
      { label: 'Application', value: 'Decorative, Functional Use' },
      { label: 'Quality', value: 'Authentic Traditional Craftsmanship' }
    ],
    exportNote: 'Authentic handmade products promoting traditional craftsmanship.'
  },
  {
    id: 'korai-pai',
    name: 'Korai Pai',
    category: 'handicrafts',
    image: koraiPaiImg,
    shortDescription: 'Traditional korai mat',
    description: 'Traditional handwoven korai mats made by skilled artisans.',
    overview: 'Traditional korai pai (mats) handwoven by skilled artisans using natural korai grass sourced from wetlands. These eco-friendly mats are carefully woven to create durable and breathable floor coverings. Each mat is inspected for quality and packed to meet export standards. These sustainable products promote traditional weaving techniques and provide natural cooling comfort for homes and meditation spaces worldwide.',
    specifications: [
      { label: 'Material', value: 'Natural Korai Grass' },
      { label: 'Production', value: 'Handwoven by Skilled Artisans' },
      { label: 'Quality', value: 'Durable & Breathable' },
      { label: 'Processing', value: 'Eco-friendly & Sustainable' },
      { label: 'Application', value: 'Floor Covering, Meditation, Traditional Use' },
      { label: 'Features', value: 'Natural Cooling Properties' }
    ],
    exportNote: 'Sustainable and durable traditional floor covering.'
  },
  {
    id: 'handheld-fan',
    name: 'Handheld Fan',
    category: 'handicrafts',
    image: handheldFanImg,
    shortDescription: 'Traditional handcrafted fan',
    description: 'Traditional handmade fans crafted by local artisans.',
    overview: 'Traditional handcrafted fans made by local artisans using natural materials such as palm leaves, bamboo, and jute. Each fan is carefully assembled and finished with traditional designs and patterns. These lightweight and durable fans provide eco-friendly cooling solutions while preserving traditional craft techniques. Packed to meet export standards for cultural products and eco-conscious markets worldwide.',
    specifications: [
      { label: 'Material', value: 'Natural Materials (Palm, Bamboo, Jute)' },
      { label: 'Production', value: 'Handcrafted by Local Artisans' },
      { label: 'Features', value: 'Lightweight & Durable' },
      { label: 'Design', value: 'Traditional Patterns & Aesthetics' },
      { label: 'Application', value: 'Cooling, Decorative, Cultural Use' },
      { label: 'Quality', value: 'Eco-friendly & Sustainable' }
    ],
    exportNote: 'Eco-friendly cooling solution with traditional aesthetics.'
  }
];

// Helper function to get products by category
export const getProductsByCategory = (categorySlug) => {
  return products.filter(product => product.category === categorySlug);
};

// Helper function to get category by slug
export const getCategoryBySlug = (slug) => {
  return categories.find(cat => cat.slug === slug);
};

// Helper function to get product by id
export const getProductById = (productId) => {
  return products.find(product => product.id === productId);
};
